import { Component, OnDestroy, OnInit } from '@angular/core';
import { StudentClass } from '@df/interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { PeopleService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-select-class',
    templateUrl: './select-class.component.html',
    styleUrls: ['./select-class.component.scss']
})
export class SelectClassComponent implements OnInit, OnDestroy {
    public teacherClasses: StudentClass[] = [];

    private destroy$ = new Subject<boolean>();

    constructor(
        private peopleService: PeopleService,
        private route: ActivatedRoute,
        private handlerService: HandlerService,
        private router: Router
    ) {}

    public ngOnInit(): void {
        this.peopleService
            .getCurrentUserClasses()
            .pipe(takeUntil(this.destroy$))
            .subscribe(resp => {
                this.handlerService.checkErrors(resp);
                this.teacherClasses = resp.data;
            });
    }

    public goToClassAccount(teacherClass: StudentClass) {
        this.router.navigate(['../', teacherClass.id], { relativeTo: this.route });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
